import { useEffect, useRef } from "react"

const useEffectOnce = (func: Function) => {
  const isInitRef = useRef(true);

  useEffect(() => {
    if (isInitRef.current) {
      isInitRef.current = false
      return func()
    }
  }, [func])
}

export default useEffectOnce